import apiServices from "../apiServices";

export const lessonsApi = {
  getLessons: async (params = {}) => {
    const {
      page = 1,
      limit = 10,
      search = "",
      sortBy = "createdAt",
      sortOrder = "desc",
    } = params;

    const queryParams = new URLSearchParams();
    queryParams.append("page", page.toString());
    queryParams.append("limit", limit.toString());

    if (search) queryParams.append("search", search);
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);

    const response = await apiServices.get(
      `/api/v1/lessons?${queryParams.toString()}`
    );
    return response.data;
  },
  getLessonsSearchFunctionality : async (params = {}) => {
    const {
      search = "",
      sortBy = "createdAt",
      sortOrder = "desc",
    } = params;

    const queryParams = new URLSearchParams();
    if (search) queryParams.append("search", search);
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);

    const response = await apiServices.get(
      `/api/v1/lessons?${queryParams.toString()}`
    );
    return response.data;
  },
  getLessonById: async (id) => {
    const response = await apiServices.get(`/api/v1/lessons/${id}`);
    return response.data;
  },
  createLesson: async (data) => {
    const response = await apiServices.post("/api/v1/lessons", data);
    return response.data;
  },
  updateLesson: async (id, data) => {
    const response = await apiServices.patch(`/api/v1/lessons/${id}`, data);
    return response.data;
  },
  deleteLesson: async (id) => {
    const response = await apiServices.delete(`/api/v1/lessons/${id}`);
    return response.data;
  },
  getAllLessons: async (params = {}) => {
    const {
      page,
      limit,
      search,
      courseId,
      sortBy,
      sortOrder,
    } = params;
    const queryParams = new URLSearchParams();
    queryParams.append("page", page.toString());
    queryParams.append("limit", limit.toString());
    if (search) queryParams.append("search", search);
    if (courseId) queryParams.append("courseId", courseId);
    if (sortBy) queryParams.append("sortBy", sortBy);
    if (sortOrder) queryParams.append("sortOrder", sortOrder);
    const response = await apiServices.get(
      `/api/v1/lessons?${queryParams.toString()}`
    );
    return response.data;
  },
  //upload and convert video to hls format for lesson (queued processing)
  uploadAndConvertVideoToHLS: async (lessonId, data) => {
    const response = await apiServices.post(`/api/v1/lessons/${lessonId}/upload-video`, data);
    return response.data;
  },

  //video processing
  // get video processing job status by job id
  getVideoProcessingJobStatus: async (jobId) => {
    const response = await apiServices.get(`/api/v1/video-processing/job/${jobId}`);
    return response.data;
  },
  // get all video processing jobs
  getAllVideoProcessingJobs: async () => {
    const response = await apiServices.get(`/api/v1/video-processing/jobs`);
    return response.data || response || [];
  }
};
